const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export const isPixelEnabled = () => Boolean(PIXEL_ID);

export const initPixel = () => {
  if (!PIXEL_ID || typeof window === "undefined") return;
  if (!window.fbq) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
    window.fbq("init", PIXEL_ID);
  }
  window.fbq("track", "PageView");
};

export const trackPixel = (event, params) => {
  if (!PIXEL_ID || typeof window === "undefined" || !window.fbq) return;
  window.fbq("track", event, params);
};

export const trackContactOnPhoneClicks = () => {
  if (typeof document === "undefined") return () => {};
  const handler = (e) => {
    const link = e.target.closest?.('a[href^="tel:"]');
    if (link) trackPixel("Contact", { content_name: "telephone", page: window.location.pathname });
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
};
